<template>
    <button id="ALLPOWER" name="ALLPOWER" class="btn" data-vcode="POWER" disabled :aria-label="`${$t('allPower')}`">
        <img src="/images/icons/power.svg" alt="" />
        <label aria-hidden="true">{{ $t('allPower') }}</label>
    </button>
</template>
<script>
export default {};
</script>
